import { Content } from "../../types/content.interface";

export const organizationsAndActivitesData: Content[] = [
  {
    enSubtitle: "AUSG(AWSKRUG University Student Group) 9th",
    krSubtitle: "AUSG(AWSKRUG University Student Group) 9기",
    enDescription: "AWS Korea User Group - University Student Chapter",
    krDescription: "AWS 한국사용자모임 대학생 소모임(연합동아리)",
    enSubDescription: "Speaker",
    krSubDescription: "발표자",
    isDisplay: true,
    date: "(25.07 ~)",
    details: [
      {
        enText: "BigChat Speaker",
        krText: "BigChat 발표자",
        isDisplay: true,
      },
      {
        enText: "Volunteer at AWS Community Day 2025",
        krText: "AWS Community Day 2025 자원봉사자로 활동",
        isDisplay: true,
      },
    ],
  },
  {
    enSubtitle: "Sogang ICPC Team",
    krSubtitle: "Sogang ICPC Team",
    enDescription: "Algorithm Study Club of Sogang Univ.",
    krDescription: "서강대학교 알고리즘 학회",
    enSubDescription: "Algorithm Study Tutor",
    krSubDescription: "알고리즘 스터디 튜터 활동",
    isDisplay: true,
    date: "(20.03 ~)",
    details: [
      {
        linkUrl:
          "https://www.youtube.com/watch?v=PEMSNWi1tLM&list=PLNsZHQX7ujN8c9BRdZIPifxU1fM7hZBBh",
        linkText: "link",
        enText:
          "2021, 2022 Spring Basic Algorithms with cpp lecture (1,3,5,7 lectures)",
        krText:
          "2021년, 2022년 봄, cpp로 기초 알고리즘 강의 (1,3,5,7 lectures)",
        isDisplay: true,
      },
    ],
  },
  {
    enSubtitle: "SWIC",
    krSubtitle: "SWIC",
    enDescription: "Sogang Wise Investment Club",
    krDescription: "서강대학교 재테크 학회",
    enSubDescription: "Team Leader (2021 1st semester, 2nd semester)",
    krSubDescription: "팀장 (2021년 1,2학기)",
    isDisplay: true,
    date: "(20.09 ~ 21.12)",
    details: [
      {
        enText:
          "Analyze companies with Python, Research on efficient portfolio optimization",
        krText: "파이썬으로 기업을 분석하고, 효율적인 포트폴리오 최적화 연구",
        isDisplay: true,
      },
      {
        enText: "Conducted a Python study for beginners within the club",
        krText: "학회 내에서 비전공자를 위해 파이썬 스터디 진행",
        isDisplay: true,
      },
      {
        enText: "Create stock backtesting and visualization programs",
        krText: "주식 백테스팅 및 시각화 프로그램을 제작",
        isDisplay: true,
      },
    ],
  },
  {
    enSubtitle: "Release",
    krSubtitle: "Release",
    enDescription: "IT Project Club of Sogang Univ.",
    krDescription: "서강대학교 프로젝트 학회",
    enSubDescription: "Speaker",
    krSubDescription: "발표자",
    isDisplay: true,
    details: [
      {
        enText:
          "Gave a presentation on ‘AWS Infrastructure Design for Web and App Operations’ (Winter 2022)",
        krText: "‘웹/앱 운영을 위한 AWS 인프라 설계'를 주제로 발표 (2022 wi)",
        isDisplay: true,
      },
      {
        enText:
          "Gave a presentation on ‘Building a Hybrid Home Server and Automated Deployment Using Raspberry Pi’ (Spring 2025)",
        krText:
          "'라즈베리파이를 이용한 하이브리드 홈서버 구축 및 자동화 배포'를 주제로 발표 (2025 sp)",
        isDisplay: true,
      },
    ],
  },
];
